import {WpEtEnrollment} from "./wp-et-enrollment.model";
import {WpPerson} from "./wp-person.model";

export class CaseNotes{
  constructor(
    public id?: number,
    public createdBy?: string,
    public createdDt?: any,
    public lastModifiedBy?: string,
    public lastModifiedDt?: any,
    public typeCd?: string,
    public notes?: string,
    public deleteSw?: string,
    public personId?: number,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/case-notes.model.ts